import React from 'react'
import { Breadcrumb, Breadcrumbs } from 'ui/navigation'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'

export default function PageBreadcrumbs () {
  const [title] = useEnvValue('page.title')
  const [route] = useEnvValue('router.currentRoute')
  const [parameters] = useEnvValue('router.currentParameters')

  const [parents] = useEnvValue('page.parents')

  return (
    <Breadcrumbs>
      {(parents && parents.length) > 0 ? parents.map(parent => {
        return (
          <Breadcrumb key={parent.route || Math.random()} route={parent.route || null}>
            {parent.titleKey ? <Translation name={parent.titleKey} /> : null}
          </Breadcrumb>
        )
      }) : null}
      <Breadcrumb text={title} route={route} parameters={parameters} active />
    </Breadcrumbs>
  )
}
